module.exports = __webpack_public_path__ + "img/continental-thumb.02f35104.png";